import type {
  DynaVault,
  DynaVaultRegistryType,
} from '../../../../api/DynaVaultsAPI';
import type { VaultStatusFilter } from 'structure/pv2/dynavault/types';

const registryVaultTypes: Record<number, DynaVaultRegistryType> = {
  1: 'DEV',
  2: 'UAT',
  3: 'BETA',
  4: 'PRODUCTION',
};

export const getRegistryVaultType = (
  vaultType: number
): DynaVaultRegistryType | undefined => registryVaultTypes[vaultType];

export const getVaultStatus = (
  vault: Pick<DynaVault, 'isClosed' | 'vaultType'>
) => {
  if (vault.isClosed) {
    return { label: 'Closed', colorClass: 'text-red-600' };
  }

  if (vault.vaultType === 'BETA') {
    return { label: 'Beta', colorClass: 'text-yellowDark' };
  }

  return { label: 'Live', colorClass: 'text-green' };
};

export const matchesVaultStatusFilter = (
  vault: Pick<DynaVault, 'isClosed' | 'vaultType'>,
  filter: VaultStatusFilter
): boolean => {
  if (filter === 'all') {
    return true;
  }

  if (filter === 'closed') {
    return vault.isClosed;
  }

  return !vault.isClosed && vault.vaultType !== 'BETA';
};
